import {Inject, Injectable, OnDestroy} from "@angular/core";
import {HttpClient, HttpHeaders} from "@angular/common/http";
import JSZip from "jszip";
import { BpConfigService } from "../../config/bp-config.service";

@Injectable({providedIn: 'root'})
export class BimForgeApiService implements OnDestroy {

  private bpApiUrl: string

  constructor(
    private readonly httpClient: HttpClient,
    configService: BpConfigService
  ) {
    this.bpApiUrl = configService.getConfig().apiUrl;
  }

  ngOnDestroy(): void {
  }

  async uploadBlob(bimModelId: string, versionId: string, blob: Blob): Promise<any> {
    const headers = new HttpHeaders({
      'Content-Type': 'application/octet-stream'
    });

    const formData = new FormData();
    formData.append('file', blob);

    return await this.httpClient.post(`${this.bpApiUrl}/forge/bim-models/${bimModelId}/versions/${versionId}/enqueue`, formData).toPromise();
  }

  async uploadFile(bimModelId: string, versionId: string, file: File): Promise<any> {
    const headers = new HttpHeaders({
      'Content-Type': 'application/octet-stream'
    });

    const formData = new FormData();
    formData.append('file', file);

    //return await this.httpClient.post(`${API_URL}/${bimModelId}/versions/${versionId}/source`, blob).toPromise();
    return await this.httpClient.post(`${this.bpApiUrl}/forge/bim-models/${bimModelId}/versions/${versionId}/enqueue`, formData).toPromise();
  }

  async uploadFileToForge(bimModelId: string, versionId: string): Promise<any> {
    return await this.httpClient.post(`${this.bpApiUrl}/forge/bim-models/${bimModelId}/versions/${versionId}/upload`, new Blob()).toPromise();
  }

  async convertFile(urn: string): Promise<any> {
    return await this.httpClient.post(`${this.bpApiUrl}/forge/bim-models/${urn}/convert`, new Blob()).toPromise();
  }

  async downloadManifest(bimModelId: string, versionId: string, urn: string): Promise<any> {
    return await this.httpClient.get(`${this.bpApiUrl}/forge/bim-models/${bimModelId}/versions/${versionId}/download/${urn}/manifest`).toPromise();
  }

  async downloadThumbnail(bimModelId: string, versionId: string, urn: string): Promise<ArrayBuffer> {
    return await this.httpClient.get(`${this.bpApiUrl}/forge/bim-models/${bimModelId}/versions/${versionId}/download/${urn}/thumbnail`, {responseType: 'arraybuffer'}).toPromise();
  }

  async downloadConvertedModel(bimModelId: string, versionId: string, urn: string): Promise<any> {
    return await this.httpClient.get(`${this.bpApiUrl}/forge/bim-models/${bimModelId}/versions/${versionId}/download/${urn}`).toPromise();
  }

  getThumbnail(bimModelId: string, versionId: string) {
    return this.httpClient.get(`${this.bpApiUrl}/forge/bim-models/${bimModelId}/versions/${versionId}/thumbnail`, {responseType: 'arraybuffer'});
  }

  async getSourceFile(bimModelId: string, versionId: string): Promise<ArrayBuffer> {
    return await this.httpClient.get(`${this.bpApiUrl}/forge/bim-models/${bimModelId}/versions/${versionId}/source`, {responseType: 'arraybuffer'}).toPromise();
  }

  async downloadSourceFile(bimModelId: string, versionId: string) {
    this.httpClient.get(`${this.bpApiUrl}/forge/bim-models/${bimModelId}/versions/${versionId}/source`, {responseType: 'arraybuffer'}).subscribe(
      (response: any) => {
        let dataType = response.type;
        let binaryData = [];
        binaryData.push(response);
        let downloadLink = document.createElement('a');
        downloadLink.href = window.URL.createObjectURL(new Blob(binaryData, {type: dataType}));
        downloadLink.setAttribute('download', 'source.zip');
        document.body.appendChild(downloadLink);
        downloadLink.click();
        downloadLink.parentNode.removeChild(downloadLink);
      }
    )
  }

  async zipFile(file: File): Promise<Blob> {
    const zip = new JSZip();
    zip.file(file.name, file);
    const zipFile = await zip.generateAsync({
      type: 'blob', compression: 'DEFLATE',
      compressionOptions: {
        level: 9
      }
    });
    return zipFile;
  }
}
